import htmlToText from 'html-to-text';

export const htmlElements = [
  'a',
  'abbr',
  'acronym',
  'address',
  'applet',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'base',
  'basefont',
  'bdi',
  'bdo',
  'bgsound',
  'big',
  'blink',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'center',
  'cite',
  'code',
  'col',
  'colgroup',
  'content',
  'data',
  'datalist',
  'dd',
  'decorator',
  'del',
  'details',
  'dfn',
  'dir',
  'div',
  'dl',
  'dt',
  'element',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'font',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'isindex',
  'kbd',
  'keygen',
  'label',
  'legend',
  'li',
  'link',
  'listing',
  'main',
  'map',
  'mark',
  'marquee',
  'menu',
  'menuitem',
  'meta',
  'meter',
  'nav',
  'nobr',
  'noframes',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'plaintext',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'section',
  'select',
  'shadow',
  'small',
  'source',
  'spacer',
  'span',
  'strike',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'template',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'tt',
  'u',
  'ul',
  'var',
  'video',
  'wbr',
  'xmp',
];

const generateRegex = () => {
  let string = '';

  htmlElements.forEach((el, index, arr) => {
    const lastItem = arr.length - 1;

    if (index === 0) {
      string = string.concat('/<', `${el}\\b(>| .+>)`);
    } else if (index === lastItem) {
      string = string.concat('|<', `${el}\\b(>| .+>)/`);
    } else {
      string = string.concat('|<', `${el}\\b(>| .+>)`);
    }
  });

  // example: /<i\b(>| .+>)|<img\b(>| .+>)|<span\b(>| .+)/
  // regexr.com/4otgm
  return RegExp(string);
};

export const htmlParser = (data, isHtml) => {
  if (isHtml) {
    return htmlToText.fromString(data, { wordwrap: false });
  }

  return data
    .split('\n')
    .map((item) => item.trim() && `<p>${item}</p>`)
    .join(' ');
};

export const parseHtmlForEmailTemplates = (data) => {
  return data
    .split('\n')
    .map((item) => item.trim())
    .map((item) => {
      if (item.includes('<p>') && !item.includes('</p>')) return `${item}</p>`;
      if (!item.includes('<p>') && item.includes('</p>')) return `<p>${item}`;
      if (!item.includes('<') && !item.includes('</')) return `<p>${item}</p>`;
      return item;
    })
    .join(' ');
};

export const checkIfHtmlAndConvertToPlain = (description) => {
  const regex = generateRegex();
  return regex.test(description) ? htmlParser(description, true) : description;
};

export const checkIfPlainAndConvertToHtml = (description) => {
  const regex = generateRegex();
  return regex.test(description) ? description : htmlParser(description);
};

export const isHtml = (description) => {
  const regex = generateRegex();
  return regex.test(description);
};

export const getHtmlForUnsubscribeLink = () => {
  const unsubscribeLink = `${process.env.ENGINE_BASE_URL}/opt_outs?uid=%{opt_out_uid}`;
  const unsubscribeLinkStyle = 'font-size: 8px; color: #828383;';
  const unsubscribeLinkHTML = `<p style="${unsubscribeLinkStyle}">If you want to stop receiving emails from me, <a style="${unsubscribeLinkStyle}" href="${unsubscribeLink}">click here.</a></p>`;
  return unsubscribeLinkHTML;
};
